import React from 'react'

export default function ShareIcon() {
    return (
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.899902 9.06706V13.7337C0.899902 14.0431 1.02282 14.3399 1.24161 14.5587C1.4604 14.7775 1.75715 14.9004 2.06657 14.9004H12.5666C12.876 14.9004 13.1727 14.7775 13.3915 14.5587C13.6103 14.3399 13.7332 14.0431 13.7332 13.7337V9.06706M7.31657 10.8171V1.19206M10.8166 4.40039L7.31657 0.900391L3.81657 4.40039" stroke="#B1AEC7" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
